(function () {
  var dataEl = document.getElementById('markdown-source-data');
  var container = document.querySelector('[data-markdown-target]');

  if (!dataEl || !container || typeof marked === 'undefined') {
    return;
  }

  var raw = dataEl.textContent;
  var content = JSON.parse(raw);

  content = content.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  container.innerHTML = marked.parse(content);

  var slots = container.querySelectorAll('[data-md-embed]');

  slots.forEach(function (slot) {
    var idx = slot.getAttribute('data-md-embed');
    var embedEl = document.getElementById('md-embed-' + idx);
    if (!embedEl) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = JSON.parse(embedEl.textContent);
    slot.replaceWith.apply(slot, Array.from(tmp.childNodes));
  });

  container.querySelectorAll('scroll-carousel.markdown-product-carousel').forEach(function (scrollArea) {
    var outer = scrollArea.closest('.markdown-carousel-outer');
    var pageDots = outer && outer.querySelector('page-dots');
    if (!pageDots) return;
    scrollArea._items = null; // invalidate cache: connectedCallback ran before children were injected
    var lastPages = 0;

    var buildDots = function () {
      var pages = scrollArea.totalPages;
      if (!pages || pages < 1) return;
      if (pages === lastPages) return;
      lastPages = pages;
      pageDots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tap-area';
        btn.setAttribute('aria-current', 'false');
        btn.innerHTML = '<span class="sr-only">Item ' + (i + 1) + '</span>';
        (function (idx) {
          btn.addEventListener('click', function () { pageDots.select(idx); });
        })(i);
        pageDots.appendChild(btn);
      }
      pageDots.items = Array.from(pageDots.children);
      pageDots.select(Math.min(scrollArea.selectedIndex || 0, pages - 1), false);
    };

    var tryBuild = function () {
      buildDots();
      if (!lastPages) requestAnimationFrame(tryBuild);
    };

    requestAnimationFrame(tryBuild);

    if (window.ResizeObserver) {
      new ResizeObserver(buildDots).observe(scrollArea);
    }
  });
})();
